module.exports = "<svg viewBox=\"0 0 152.3 144.3\"><path fill=\"#1E1E1C\" d=\"M24.1 144.3h29.6c2.8 0 5-2.3 5-5V86.1h34.9v53.2c0 2.8 2.3 5 5 5h29.6c2.8 0 5-2.3 5-5v-68H19.1v68c0 2.8 2.2 5 5 5zm48.7-143L1 66c-2.1 1.9-.7 5.3 2 5.3l146.2-.1c2.8 0 4.1-3.4 2-5.3L79.5 1.3c-1.9-1.7-4.8-1.7-6.7 0z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/offer-address.svg
// module id = 237
// module chunks = 1